import React from 'react';

// Decorative organic SVG "motifs" (nuraform-inspired flourishes).
// Purely decorative — marketing surfaces only. Absolutely positioned by parent.
// Usage: <Motif shape="star" className="absolute -top-6 right-10 w-16 text-warm-yellow motif-float" />
const SHAPES = {
  star: (
    <path d="M50 2c4 26 22 44 48 48-26 4-44 22-48 48-4-26-22-44-48-48 26-4 44-22 48-48z" />
  ),
  blob: (
    <path d="M43 6c17-8 42 2 48 22s-6 40-20 52-38 18-53 7S3 54 9 34 26 14 43 6z" />
  ),
  squiggle: (
    <path
      d="M4 40c14-24 30-24 46 0s32 24 46 0"
      fill="none"
      strokeWidth="8"
      strokeLinecap="round"
    />
  ),
  ring: (
    <circle cx="50" cy="50" r="40" fill="none" strokeWidth="8" />
  ),
  petal: (
    <path d="M50 4C30 24 10 40 10 62a40 40 0 0080 0c0-22-20-38-40-58z" />
  ),
};

export function Motif({ shape = 'star', className = '', stroke = false, ...props }) {
  const node = SHAPES[shape] || SHAPES.star;
  const isStroke = stroke || shape === 'squiggle' || shape === 'ring';
  return (
    <svg
      viewBox="0 0 100 100"
      aria-hidden="true"
      className={className}
      fill={isStroke ? 'none' : 'currentColor'}
      stroke={isStroke ? 'currentColor' : 'none'}
      {...props}
    >
      {node}
    </svg>
  );
}

export default Motif;
